export default function TotalTransactionsIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
    >
      <path
        d="M2.91675 14C2.91675 8.77523 2.91675 6.16285 4.53986 4.53974C6.16299 2.91663 8.77535 2.91663 14.0001 2.91663C19.2248 2.91663 21.8372 2.91663 23.4604 4.53974C25.0834 6.16285 25.0834 8.77523 25.0834 14C25.0834 19.2247 25.0834 21.8371 23.4604 23.4601C21.8372 25.0833 19.2248 25.0833 14.0001 25.0833C8.77535 25.0833 6.16299 25.0833 4.53986 23.4601C2.91675 21.8371 2.91675 19.2247 2.91675 14Z"
        stroke="currentColor"
        stroke-width="1.5"
      />
      <path
        d="M8.20947 14.0321H16.3476M16.3476 14.0321C16.3476 14.6976 13.8332 16.934 13.8332 16.934M16.3476 14.0321C16.3476 13.3491 13.8332 11.1569 13.8332 11.1569M19.8761 9.32764V18.661"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </svg>
  );
}
